import React from 'react';
import Button from './Button';

import terra from "../images/terra.jpg"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    first: {
        width: "100%",
        minHeight: "600px",
        backgroundImage: `url(${terra})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 800px",
        display: "flex",
        position: "relative",
    },
    bottom: {
        position: "absolute",
        float: "right",
        right: 0,
        bottom: 0,
        width: "50%"
    },
    header: {
        display: "flex",
        float: "right",
        backgroundColor: "yellow",
        height: "50px"
    }
}));

function HomeDesc() {
    const classes = useStyles()

    return (
        <div className={classes.first} >
            <h1 className={classes.header} >La nostra terra </h1>

            <div className={classes.bottom}>
                <a href="/chi-siamo" className={classes.bottom}>
                    <Button variant="contained" name="SCOPRI CHI SIAMO" />
                </a>
            </div>
        </div>
    );
}

export default HomeDesc;
